var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { GetHistoryCreator, SetHistoryCreatorInstance } from '@shared/utils/History/IHistoryMergerCreator';
import { HistoryMergerCreator } from './Aggregations/HistoryMergerCreator';
import { ReloadHistoryParams } from '@shared/utils/History/ReloadHistoryParams';
import { ErrorInformationStorage } from '../../ErrorInformationStorage';
import { Connection } from '../../Connection';
import { HistoryMergerInputParams } from '@shared/utils/History/HistoryMergerInputParams';
import { Periods } from '@shared/utils/History/TFInfo';
class _HistoryManager {
    constructor() {
        SetHistoryCreatorInstance(HistoryMergerCreator);
    }
    reloadHistory(cashItem, historyParams, signal, isNeedRealTime) {
        return __awaiter(this, void 0, void 0, function* () {
            if (historyParams == null) {
                historyParams = new ReloadHistoryParams();
            }
            const intervals = yield this.getHistory(historyParams, signal);
            const aggregatedByServer = historyParams.ShouldCheckAggregatedPeriods;
            const expandAndMergeIntervals = this.expandAndMergeHistory(intervals, !aggregatedByServer, historyParams);
            cashItem.historyLoaded(expandAndMergeIntervals, historyParams, isNeedRealTime);
        });
    }
    getHistory(historyParams, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const conn = Connection;
                if (!conn) {
                    return [];
                }
                const copyHistoryParams = new ReloadHistoryParams(historyParams);
                const intervals = yield conn.GetHistoryPromise(copyHistoryParams, signal);
                historyParams.ShouldCheckAggregatedPeriods = copyHistoryParams.ShouldCheckAggregatedPeriods;
                historyParams.count = copyHistoryParams.count;
                return intervals;
            }
            catch (ex) {
                ErrorInformationStorage.GetException(ex);
                return [];
            }
        });
    }
    expandAndMergeHistory(history, needAggregate, historyParams) {
        const tfInfo = historyParams.TimeFrameInfo;
        const originalPeriod = tfInfo.Periods;
        const step = this.getBasePeriodExtended(originalPeriod);
        let historyN = history;
        if (step !== 1 && needAggregate) {
            const inputParams = new HistoryMergerInputParams();
            inputParams.BaseHistory = history;
            inputParams.NewPeriod = originalPeriod;
            inputParams.Account = historyParams.Account;
            inputParams.Instrument = historyParams.Instrument;
            inputParams.ShowExtendedSession = !tfInfo.SessionInfo.OnlyMainSession;
            const historyMerger = GetHistoryCreator().GetHistoryMerger(inputParams);
            historyN = historyMerger.MergeHistory();
        }
        return historyN;
    }
    getBasePeriodExtended(period) {
        if (period < Periods.TIC) {
            return Math.abs(period);
        }
        else if (period === Periods.TIC || period === Periods.RANGE) {
            // Тиков - один
            return 1;
        }
        else if (period % Periods.SECOND === 0) {
            // Начинаем деление с самого большого базового периода
            // ~ 5 тиков на секунду
            return 5 * (period / Periods.SECOND);
        }
        else if (period % Periods.YEAR === 0 ||
            period % Periods.MONTH === 0 ||
            period % Periods.WEEK === 0 ||
            period % Periods.DAY === 0) {
            // Количество базовых баров для формирования одного расширенного бара
            return period / Periods.DAY;
        }
        else {
            // Количество базовых баров для формирования одного расширенного
            return period / Periods.MIN;
        }
    }
}
export const HistoryManager = new _HistoryManager();
